require("./brokerConvenienceTestResult.scss");
const { FormattedText } = require("core/i18n").i18n;

// @vendors
const React = require("react");
const PropTypes = require("prop-types");

// @components
const { Accordion } = require("commonsComponents/accordion");
const { AccordionHeader } = require("commonsComponents/accordionHeader");
const { AccordionBody } = require("commonsComponents/accordionBody");
const BrokerConvenienceTestResultItem = require("../brokerConvenienceTestResultItem/brokerConvenienceTestResultItem");

// @utilities
const { summaryFormat } = require("mifid/utilities/mifidFormatTestHelpper");
class BrokerConvenienceTestResult extends React.Component {
    constructor(props) {
        super(props);
    }

    buildAccordionContent() {
        const { immBrokerConvenienceMiFIDTest } = this.props;
        const questions = immBrokerConvenienceMiFIDTest.getIn(["test", "schema"]).toJS();
        const summaryObj = summaryFormat(questions);

        return Object.keys(summaryObj).map((key) => {
            return (
                <BrokerConvenienceTestResultItem
                    title={key}
                    responses={summaryObj[key]}
                />
            );
        });
    }

    render() {
        return (
            <Accordion customClassName="br-convenience-test-accordion" isExpanded={true}>
                <AccordionHeader
                    name="AccordionHeader"
                    iconStyle
                    toggleAccordianContent
                >
                    <div className="br-convenience-test-accordion__info-section--separator">
                        <div className="br-convenience-test-accordion__header-title">
                            <FormattedText value="broker-convenienveMifidTestConfirmationAccordionHeaderTitle"/>
                        </div>
                        <div className="br-convenience-test-accordion__investor-description">
                            <FormattedText value="broker-convenienveMifidTestConfirmationAccordionHeaderDescription"/>
                        </div>
                        <div className="br-convenience-test-accordion__header-title">
                            <FormattedText value="broker-convenienveMifidTestConfirmationAccordionTitle"/>
                        </div>
                    </div>
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    <div className="br-convenience-test-accordion__description--separator">
                        {this.buildAccordionContent()}
                    </div>
                </AccordionBody>
            </Accordion>
        );
    }
}

BrokerConvenienceTestResult.propTypes = {
    alwaysShowSeparator: PropTypes.boolean,
    bodyRiskProfileDescription: PropTypes.string,
    clientRiskProfile: PropTypes.string.isRequired,
    headerRiskProfileDescription: PropTypes.object,
    lastResultInvestorLabel: PropTypes.string,
    legalTextDescription: PropTypes.object,
    productDescription: PropTypes.string,
    sustainabilityProfile: PropTypes.object,
    immBrokerConvenienceMiFIDTest: PropTypes.object,
};

BrokerConvenienceTestResult.defaultProps = {
    alwaysShowSeparator: false,
    sustainabilityProfile: null,
};

module.exports = BrokerConvenienceTestResult;
